import {
  ModIconButton,
  ModTooltip
} from '@moderneinc/design-system-components';
import { iconSize } from '@moderneinc/design-system-tokens';
import { ClickAwayListener, Popper } from '@mui/material';
import {
  bindPopper,
  bindToggle,
  type PopupState
} from 'material-ui-popup-state/hooks';
import React, { type FunctionComponent } from 'react';
import {
  topNavIconButtonActiveSx,
  topNavIconButtonSx
} from '../../../constants/sx';
import { useMenuTriggerTooltip } from '../../../hooks/use-menu-trigger-tooltip.hook';
import { HelpIcon } from '../../../icons/icons';
import { TopNavMenuPaper } from '../top-nav-menu-paper.styled';
import { HelpMenuContent } from './help-menu-content.component';

type HelpMenuPopoverProps = {
  popoverState: PopupState;
};

export const HelpMenuPopover: FunctionComponent<HelpMenuPopoverProps> = ({
  popoverState
}) => {
  const tooltipProps = useMenuTriggerTooltip(popoverState.isOpen);
  const handleClickAway = () => {
    popoverState.close();
  };

  return (
    <React.Fragment>
      <ModTooltip title="Help & resources" {...tooltipProps}>
        <ModIconButton
          aria-label="Help and resources"
          {...bindToggle(popoverState)}
          variant="nav"
          active={popoverState.isOpen}
          sx={
            popoverState.isOpen ? topNavIconButtonActiveSx : topNavIconButtonSx
          }
        >
          <HelpIcon size={iconSize.xl} />
        </ModIconButton>
      </ModTooltip>
      <Popper
        {...bindPopper(popoverState)}
        placement="bottom-end"
        disablePortal={false}
        sx={{ zIndex: (theme) => theme.zIndex.snackbar }}
        modifiers={[
          {
            name: 'offset',
            options: { offset: [0, 8] }
          }
        ]}
      >
        <ClickAwayListener onClickAway={handleClickAway} mouseEvent="onClick">
          <TopNavMenuPaper sx={{ pt: 1, pb: 2 }}>
            <HelpMenuContent onItemSelect={popoverState.close} />
          </TopNavMenuPaper>
        </ClickAwayListener>
      </Popper>
    </React.Fragment>
  );
};
